<template>
  <div>
    <!-- FAB ayuda form-->
    <v-fab-transition>
      <v-btn
        key="contact"
        color="primary"
        fab
        dark
        bottom
        right
        fixed
        @click="dialogoAyudaForm= true"
        class="v-btn--example"
      >
        <v-icon>mdi-help</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- Dialogo ayuda form-->
    <v-dialog v-model="dialogoAyudaForm" max-width="600" :fullscreen="$vuetify.breakpoint.xs">
      <v-card class>
        <v-card-text class="py-8">
          <v-select
            :items="$store.state.soporte.selectSoporte"
            v-model="select"
            label="Seleccione el tipo de ayuda"
          />
          <v-container v-if="isPlataforma">
            <v-row>
              <v-text-field
                v-model="plataforma.email"
                label="Email contacto (opcional)"
                :error-messages="emailErrors"
                @input="$v.plataforma.email.$touch()"
                @blur="$v.plataforma.email.$touch()"
              />
            </v-row>
            <v-row>
              <v-text-field v-model="plataforma.telefono" label="Teléfono (opcional)" />
            </v-row>
            <v-row class="">
              <v-textarea
                class=""
                v-model="plataforma.mensaje"
                label="¿Que problema se ha encontrado?"
                :error-messages="mensajeErrors"
                @input="$v.plataforma.mensaje.$touch()"
                @blur="$v.plataforma.mensaje.$touch()"
              />
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-2" text @click="dialogoAyudaForm = false">Cerrar</v-btn>
          <v-btn color="primary" class="px-8" @click="send" :loading="loading" v-if="select != null">Enviar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required, email, minLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  name: "DialogoSoporte",
  mixins: [validationMixin],
  validations: {
    plataforma: {
      email: { email },
      mensaje: { required, minLength: minLength(8) }
    }
  },
  data() {
    return {
      dialogoAyudaForm: false,
      select: null,
      plataforma: {
        email: "",
        telefono: "",
        mensaje: ""
      },
      loading: false
    };
  },
  watch: {
    dialogoAyudaForm(v) {
      !v || this.limpiarCampos();
    },
    select(newV, oldV) {
      switch (newV) {
        case "plataforma":
          if (this.$store.state.auth.isLogged) {
            this.plataforma.email = this.$store.state.auth.user.email
              ? this.$store.state.auth.user.email
              : "";
            this.plataforma.telefono = this.$store.state.auth.user.phoneNumber
              ? this.$store.state.auth.user.phoneNumber
              : "";
          }
          break;
      }
    }
  },
  computed: {
    isPlataforma() {
      return this.select == "plataforma";
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.plataforma.email.$dirty) return errors;
      !this.$v.plataforma.email.email && errors.push("Email no correcto");
      return errors;
    },
    mensajeErrors() {
      const errors = [];
      if (!this.$v.plataforma.mensaje.$dirty) return errors;
      !this.$v.plataforma.mensaje.required && errors.push("Mensaje requerido");
      !this.$v.plataforma.mensaje.minLength && errors.push("Demasiado corto.");
      return errors;
    }
  },
  methods: {
    limpiarCampos() {
      this.plataforma = {
        email: "",
        telefono: "",
        mensaje: ""
      };
      this.select = null;
      this.$v.$reset();
    },
    sendPlataforma() {
      if (this.$v.$invalid) {
        this.$v.$touch();
      } else {
        let _vm = this;
        _vm.loading = true;
        this.$recaptcha("soporte").then(r => {
          this.plataforma.captcha = r;

          return this.$store
            .dispatch("soporte/sendPlataforma", this.plataforma)
            .then(() => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Hemos enviado su incidencia al soporte. Muchas Gracias"
              });
              _vm.dialogoAyudaForm = false;
            })
            .catch(e => {
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "No se ha podido enviar la incidencia: " + e
              });
            })
            .finally(() => (_vm.loading = false));
        });
      }
    },
    send() {
      switch (this.select) {
        case "plataforma":
          this.sendPlataforma();
          break;
      }
    }
  }
};
</script>

<style scoped>
.border {
  border: 1px solid #000;
}
</style>